import './publications.less'

import {m, MediaQuery, classes} from '@codeurs/front'
import {PublicationLabel} from 'types'
import {Filters, Toggle} from 'views/filter'
import Layout from 'views/layout'
import {Aside} from 'views/layout/aside'
import ContentContainer from 'views/layout/contentcontainer'
import Title from 'views/layout/title'
import {pagedFilters, PagedLoader} from 'views/loader/pagedloader'
import PublicationLink from 'views/partials/features/publicationlink'
import {t} from 'store'

let filterclosed = true

const PublicationsAside = ({sectors, sector}) => [
	m(Title, {heading: 4}, 'Filter by Sector(s)'),
	m('.publications-sectors',
		m(Filters,
			{filter: sector, style: 'aside'},
			Object.entries(sectors).map(([id, sector]) => m(Toggle, {id}, sector))
		)
	)
]

export class Publications extends Layout {
	state = pagedFilters(({single, multiple}) => ({
		theme: multiple('theme'),
		sector: single('sector'),
		label: single('label')
	}))
	view() {
		const {
			lists: {sectors, policies, tags, authors}
		} = this.attrs.data
		const {theme, sector, label} = this.state
		return m('.publications',
			m(ContentContainer, {mod: 'tight'}, [
				m(MediaQuery, {
					maxWidth: 767,
					view: () =>
						m('.publications-toggle',
							{
								...classes({mod: filterclosed ? '' : 'active'}, 'more'),
								ontouchstart: () => (filterclosed = !filterclosed)
							},
							t('publications.filter')
						)
				}),
				m('.publications-themes',
					{class: filterclosed ? ' mod-isfolded' : ''},
					m(Title, {heading: 4}, 'Filter by Theme(s)'),
					m(Filters,
						{filter: theme, style: 'theme'},
						Object.entries(policies).map(([id, policy]) =>
							m(Toggle, {id}, policy.name)
						)
					)
				),
				m(Aside,
					{
						showfilter: filterclosed ? true : false,
						aside: () => m(PublicationsAside, {sector, sectors})
					},
					[
						m('.publications-categories',
							{class: filterclosed ? ' mod-isfolded' : ''},
							m(Filters,
								{filter: label, style: 'category'},
								Object.entries(PublicationLabel).map(([id, label]) =>
									m(Toggle, {id}, label)
								)
							)
						),
						m('.publications-loader',
							m(PagedLoader,
								{
									url: '/api/cms/publications',
									filters: this.state
								},
								({data}) =>
									data.map(publication =>
										m(PublicationLink, {
											key: publication.id,
											mod: 'filtered',
											publication: {
												...publication,
												author: authors.find(
													author => `${author.id}` === publication.author[0]
												)
											},
											tags: publication.tags.map(tag => tags[tag])
										})
									)
							)
						)
					]
				)
			])
		)
	}
}
